import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router's client-side navigation doesn't reset scroll position by
 * default — clicking a footer link or navbar CTA while scrolled down on the
 * current page lands you on the new page still scrolled down. This mounts
 * once inside the router and scrolls to top on every route change.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
